document.addEventListener("DOMContentLoaded", () => {
  const bubble = document.getElementById("bevMessengerBubble");
  const close = document.querySelector(".bev-close");

  if (!bubble) return;

  // Si la bulle a déjà été fermée pendant cette visite
  if (sessionStorage.getItem("bevMessengerClosed")) return;

  // Affichage après 8 secondes
  setTimeout(() => {
    bubble.classList.add("is-visible");
  }, 8000);

  // Fermeture
  if (close) {
    close.addEventListener("click", () => {
      bubble.classList.remove("is-visible");
      sessionStorage.setItem("bevMessengerClosed", "true");
    });
  }
});